import { render, staticRenderFns } from "./ProductivityBar.vue?vue&type=template&id=4e1773e2"
import script from "./ProductivityBar.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductivityBar.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports